var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',{staticClass:"main-wrapper wp"},[_c('router-view')],1),_c('footer',{staticClass:"footer"},[_vm._v("\n        © 2017-2019 阿特拉斯·科普柯公司版权所有\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }